import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-stock-transfer-log',
  templateUrl: './stock-transfer-log.component.html',
  styleUrls: ['./stock-transfer-log.component.css']
})
export class StockTransferLogComponent implements OnInit {
    stockTransferKeyno;

    public setting?: Setting;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockTransferKeyno = this.stateService.getStateParams()['stocktransfer_keyno'];
    }

    private async loadSetting() {
        if (!!this.stockTransferKeyno) {
            this.setting = (await this.datatask.Post(2319, { stocktransfer_keyno: this.stockTransferKeyno }))[0];
        }
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_stocktransferlog_grid')
                .setLoadDataFunction({
                    method: 2318,
                    parameters: { stocktransfer_keyno: this.setting.stocktransfer_keyno }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    webpage_heading: string;
    stocktransfer_keyno: string;
}
